import React from 'react';
import { ChatBot } from '../../services/dashboard/GetChatBots';
import '../../styles/dash/CardBots.css';
import nothingImage from '../../assets/auth/nothing.png';

interface CardBotsProps {
  bot: ChatBot;
  onToggleStatus: (id: number) => void;
  onEdit: () => void;
  permisos: number[];
}

const CardBots: React.FC<CardBotsProps> = ({ bot, onToggleStatus, onEdit, permisos }) => {
  
  const getImageSource = (botIcono: string): string => {
    const URL_BACK_IMGBOT = process.env.REACT_APP_API_IMGBOT_URL;

    return `${URL_BACK_IMGBOT}${botIcono}`;
  };

  const statusText = bot.status === 1 ? 'Activo' : 'Inactivo';
  const statusColor = bot.status === 1 ? 'status-active' : 'status-inactive';
  const powerButtonText = bot.status === 1 ? 'Desactivar' : 'Activar';
  const powerButtonColorClass = bot.status === 1 ? 'power-off' : 'power-on';

  return (
    <div className="bot-card">
      <div
        className="bot-color-header"
        style={{ backgroundColor: bot.color }}
      ></div>

      <div className="bot-card-content">
        <div className="bot-header">
          <div
            className="bot-icon-container"
            style={{
              border: `3px solid ${bot.color}`,
              boxShadow: `0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)`
            }}
          >
            <img
              src={getImageSource(bot.icono)}
              alt={bot.nombre}
              className="bot-icon"
            />
          </div>
          <div className="bot-title">
            <h3>{bot.nombre}</h3>
            <div className="bot-status">
              <span className={`status-dot ${statusColor}`}></span>
              <span>{statusText}</span>
            </div>
          </div>
        </div>

        <div className="bot-details">
          <div className="detail-row">
            <span className="detail-label">Cliente ID:</span>
            <span className="detail-value">{bot.idCliente}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Key:</span>
            <span className="detail-value truncate">{bot.key}</span>
          </div>
          <div className="bot-actions">
            {/* Botón de Power (Activar/Desactivar) */}
            <button
              disabled={!permisos.includes(10)}
              className={`action-button power ${powerButtonColorClass}`}
              title={powerButtonText}
              onClick={() => onToggleStatus(bot.id)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="2" x2="12" y2="8" />
              </svg>
            </button>

            {/* Botón de Editar */}
            <button
              disabled={!permisos.includes(11)}
              className="action-button edit"
              title="Editar"
              onClick={onEdit} // Agrega este onClick
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardBots;